import { useEffect, useRef } from 'react'
import { VideoProps } from './types'

export const Video = ({ currentMedia, previousMedia }: VideoProps) => {
  const ref = useRef<HTMLVideoElement | null>(null)

  useEffect(() => {
    if (!ref.current) {
      return
    }

    ref.current.play()

    // The start timestamp is prev video's end timestamp or 0
    const startTimestamp =
      (previousMedia?.type === 'media_video' &&
        previousMedia?.settings?.end_timestamp) ||
      0

    const endTimestamp =
      currentMedia.settings.end_timestamp ?? ref.current.duration

    // Reset video to the start timestamp if it's further than the start timestamp (i.e. user went back)
    if (ref.current.currentTime > startTimestamp) {
      ref.current.currentTime = startTimestamp
    }

    // Pause the video at the end timestamp - current timestamp
    const timeout: number = window.setTimeout(
      () => ref.current?.pause(),
      (endTimestamp - ref.current.currentTime) * 1000,
    )

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [currentMedia, previousMedia])

  return (
    <video
      autoPlay
      loop
      muted
      playsInline
      className="w-full h-full object-cover"
      ref={ref}
    >
      {currentMedia.settings.video.sources
        .sort((a, b) => b.width - a.width)
        .map((videoSource) => (
          <source
            key={videoSource.url}
            src={videoSource.url}
            width={videoSource.width}
            height={videoSource.height}
          />
        ))}
    </video>
  )
}
